import { useState } from "react";

const DEFAULT_INITIAL_ROWS = 5;
const DEFAULT_MAX_ROWS = 20;

const PricingResultsCard = ({ pricingResults }) => {
  const [showAll, setShowAll] = useState(false);

  if (!pricingResults || !Array.isArray(pricingResults.rows)) {
    return null;
  }

  const columns = Array.isArray(pricingResults.columns)
    ? pricingResults.columns
    : [];
  const initialRows =
    pricingResults.initialDisplayRows || DEFAULT_INITIAL_ROWS;
  const maxRows = pricingResults.maxDisplayRows || DEFAULT_MAX_ROWS;
  const rows = pricingResults.rows.slice(0, maxRows);
  const visibleRows = showAll ? rows : rows.slice(0, initialRows);
  const hiddenRowsCount = Math.max(rows.length - visibleRows.length, 0);
  const scenarioItems = pricingResults.scenario?.items || [];

  return (
    <div className="pricing-results-card">
      {scenarioItems.length > 0 && (
        <div className="pricing-scenario-card">
          <div className="pricing-results-title">Scenario used</div>
          <div className="pricing-scenario-grid">
            {scenarioItems.map((item) => (
              <div className="pricing-scenario-item" key={item.label}>
                <span className="pricing-scenario-label">{item.label}</span>
                <span className="pricing-scenario-value">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="pricing-results-table-header">
        <div>
          <div className="pricing-results-title">Top pricing results</div>
          <div className="pricing-results-subtitle">
            Showing {visibleRows.length} of {rows.length} available options.
          </div>
        </div>
      </div>

      <div className="table-scroll-wrapper pricing-results-table-wrapper">
        <table>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibleRows.map((row) => (
              <tr key={`${row.rank}-${row.investor}-${row.product}`}>
                {columns.map((column) => (
                  <td key={column.key}>{row[column.key] || "N/A"}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {rows.length > initialRows && (
        <button
          type="button"
          className="show-more-sources-text pricing-show-more-button"
          onClick={() => setShowAll((current) => !current)}
        >
          {showAll ? "Show less" : `Show ${hiddenRowsCount} more`}
        </button>
      )}
    </div>
  );
};

export default PricingResultsCard;
